export interface DomainSectionProps {
  name: string;
  category_file: FileList;
  content_file: FileList;
}

export class DomainSection {
  public readonly name: string;
  public readonly category_file: File;
  public readonly content_file: File;

  constructor(data: DomainSectionProps) {
    this.name = data.name;
    this.category_file = data.category_file[0];
    this.content_file = data.content_file[0];
  }
}
